import { render, staticRenderFns } from "./VoucherReceipt.vue?vue&type=template&id=34970807"
import script from "./VoucherReceipt.vue?vue&type=script&lang=js"
export * from "./VoucherReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports